import { render, staticRenderFns } from "./WorkflowPage.vue?vue&type=template&id=c65c855a&scoped=true&"
import script from "./WorkflowPage.vue?vue&type=script&lang=js&"
export * from "./WorkflowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65c855a",
  null
  
)

export default component.exports